import { Scope } from './types';
import { IShellDAO } from '../../dao/IShellDAO';
import { AbstractRepository } from './../AbstractRepository';

export class ScopeRepository extends AbstractRepository<Scope[]> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellUserScopes',
      enableSanitizer
    });
  }

  saveAll(): void {
    console.debug('Not supported in ScopeRepository.');
    throw new Error('Method not implemented.');
  }

  findAll(id?: string): Scope[][] {
    console.debug('Not supported in ScopeRepository.');
    throw new Error('Method not implemented.');
  }

  delete(): boolean {
    console.debug('Not supported in ScopeRepository.');
    throw new Error('Method not implemented.');
  }
}
